import {request} from "../request/request";

const password = {
  getReset: (token) => request.read(`/password/reset/${token}`),
  postRequestReset: (data) => request.create('/password/request-reset', data),
  postReset: (data) => request.create('/password/reset', data),
};

export {password};